import { galleryHero } from "./gallery-data";
import { stockHero, PHOTO } from "./stock-images";

/**
 * The hero photograph on each page that has one — in every case the page's LCP
 * element.
 *
 * Collected here, with relative imports only, so vite.config.ts can read them
 * while building index.html. That lets the shell start fetching the right hero
 * before the app bundle has parsed; measured on /about, waiting for React to
 * request it cost over two seconds of LCP.
 *
 * Pages whose hero is text on a gradient (blog index, gallery, locations) have
 * no entry: there is nothing to preload.
 */
export const pageHeroes = {
  "/": galleryHero(29),
  "/about": galleryHero(22),
  "/services": stockHero(PHOTO.vacuumingLivingRoom),
} as const;
